import styles from "./voiceMailInnerTop.module.scss";
import { Tooltip,Dropdown,Menu } from "antd";
import { StatusTag } from "../../../../../shared/widgets/statusTag";
import React, { useState } from "react";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import statusimg from "../../../../../styles/images/profile-status-icon.svg";
import { gotoChat, makeFavourite, secondsToHMSConverter, timeStampConverter, toastInformation, userStatusColor,
  voiceMaillInnertopDate
} from "../../../../../base/callService/common";
import { useSelector } from "react-redux";
import { initiateCall, sendDirectVideoCallRequest } from "../../../../../base/callService/callService";
import { useHistory } from "react-router-dom";
import { initialStateModel } from "../../../../../models/model";
import { handleMute, unmuteNotification } from "../../../../../base/socketChatService/utils";
import { storeChatWindow } from "../../../../../base/callService/store_mining";

export default function VoiceMailInnerTop() {
  let { callReducer}: initialStateModel = useSelector((state: initialStateModel) => state);
  let {  particularLog } = callReducer;
    const history = useHistory();
  let formatDate: any = voiceMaillInnertopDate(particularLog?.created_date).split(" ");

  const videoMeet =(particularLog:any) =>{
    if(particularLog?.ext) { 
      sendDirectVideoCallRequest(particularLog);  
  }
    else { toastInformation("Please check the number","failure"); }
  }

  return (
    <>
      <div className={styles.mainprofiles}>
        <div className={`${styles.profiledetails}`}>
          <div className={styles.userAvDt}>
            <URAvatarGroup className='lefts size82 noOutline'
              profileInfo={particularLog?.ImageURL &&
                particularLog?.ImageURL !== "" ?
                <>
                  <img src={particularLog?.ImageURL} alt="" />
                  <URStatusDot className={userStatusColor(particularLog?.user_status, 'big')} /></> :
                <>
                  <span>{particularLog?.caller_id?.charAt(0).toUpperCase()} </span>
                  <URStatusDot className={userStatusColor(particularLog?.user_status, 'big')} /></>
              } />
          </div>
          <div className={styles.userDt}>
            <p className={styles.userName} onClick={()=>storeChatWindow(particularLog)}
              title="View contact details">{particularLog?.caller_id}</p>
            
            <Tooltip placement="top"
              title={particularLog?.is_favourite === 1 ? "Remove Favourite" : 'Add Favourite'}>
              <span className={particularLog?.is_favourite === 1 ?
                         `icon_starfill cgreen ${styles.active} ` : 'icon_star'}
                onClick={() => makeFavourite(particularLog?.is_favourite === 0 ? 1 : 0,particularLog)}>
              </span></Tooltip>
             {(particularLog?.is_muted === 0) ?
                        <Tooltip placement="top" title={((particularLog?.is_muted === 0) )&& "Mute all notifications"}>
                            <Dropdown trigger={["click"]} overlay={ <Menu onClick={(e:any)=>handleMute(e,particularLog)}>
                            <Menu.Item key={"Until 8:00 AM"}>Until 8:00 AM</Menu.Item>
                            <Menu.Item key={"1 Hr"}>1 Hr</Menu.Item>
                            <Menu.Item  key={"12 Hr"}>12 Hrs</Menu.Item>
                            <Menu.Item key={"1 Week"}>1 Week</Menu.Item>
                            <Menu.Item key={"Always"}>Always</Menu.Item>
                            </Menu>} placement="bottomCenter"><span className={((particularLog?.is_muted === 0)) ?
                                styles.bellNotification : ` ${styles.bellNotification} ${styles.active}`}></span></Dropdown>
                        </Tooltip>
                    :
                      (particularLog?.is_muted=== 1 )&&
                      <Tooltip placement="top" title="Unmute all notifications">
                          <span onClick={()=>unmuteNotification(particularLog)} className={((particularLog?.is_muted===1 && particularLog?.sip_login_id) )?` ${styles.bellNotification} ${styles.active}`: styles.bellNotification}></span>
                        </Tooltip> }
            

          </div>
          <div className={styles.actionIcon}>
            <div className={styles.callIcon}
              onClick={() => initiateCall(particularLog?.ext || particularLog?.cid_number, 'audio')}><span>
              </span> Call</div>
            <div className={styles.chatIcon}
              onClick={() =>gotoChat(particularLog, history)} ><span></span> Chat</div>
            <div className={styles.meetIcon} onClick={() => videoMeet(particularLog)}><span></span> Meet</div>
          </div>
          <div className={styles.profileDt}>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <div className={styles.leftsidetxt}>
                <p>Department</p>

              </div>
              <div className={styles.rightsidetxt}>
                <p>{particularLog?.department ? particularLog?.department : "Not Available"}</p>
              </div>
            </div>
            <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
              <div className={styles.leftsidetxt}>
                <p>Extension</p>
              </div>
              <div className={styles.rightsidetxt}>
                <p>{particularLog?.cid_number}</p>
              </div>
            </div>
            <div className={`${styles.rowFlex} `}>
              <div className={styles.leftsidetxt}>
                <p>My Numbers</p>
              </div>
              <div className={styles.rightsidetxt}>
                <div className={styles.phoneNumbrtxt}>
                  {/* <Tooltip placement="top" title="Company Switch number"><p>442034440424</p></Tooltip> */}
                  {particularLog?.department ?
                    <Tooltip placement="top" title="Worktual number">
                    
                      <p> {particularLog?.department}</p></Tooltip>
                      :<p> {'Not Available'}</p>}
                  
                  <Tooltip placement="top" title="Mobile number"><p>{particularLog?.mobileno}</p></Tooltip>
                  <Tooltip placement="top" title="International number"><p></p></Tooltip>
                </div>
              </div>
            </div>
            
            <div className={`${styles.rowFlex} `}>
              <div className={styles.leftsidetxt}>
                <p>Email</p>
              </div>
              <div className={styles.rightsidetxt}>
                <div className={styles.emailtxt}>
                  <Tooltip placement="top" title={particularLog?.email_id}>
                    <p>{particularLog?.email_id?particularLog?.email_id:'Not Available'}</p></Tooltip>
                  {/* <Tooltip placement="top" title="johnywade.12465@vectone.com">
                  <p>johnywade.johny.wa@vectone.com</p></Tooltip> */}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.workingStatus}>
            <StatusTag className='statusTag bgGrey' name='Working remotely' />
            <span><img src={statusimg} alt="" /></span>
          </div>
        </div>
        {/* {voiceValues.status_msg && <div className={styles.workingStatus}>
          <StatusTag className='statusTag bgGrey' name={voiceValues.status_msg} />
          <span><img src={statusimg} alt="" /></span>
        </div>} */}
      
      </div>
      {
          formatDate[0] !== "undefined" && <div className={styles.actionDetailsIcon}>
            <span className="icon_datepick"></span>
            <span>{timeStampConverter(particularLog?.created_date,'group')}</span>
            <span className="icon_clock"></span>
            <span>{`${formatDate[2]} ${formatDate[3]}`}</span>
            <span className="icon_timer"></span>
            <span>{secondsToHMSConverter(parseInt(particularLog?.wav_duration))}</span>
          </div>
        }
    </>
  );
};
